import { useEffect, useState } from 'react';
import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import MenuIcon from '@mui/icons-material/Menu';
import CircularProgress from '@mui/material/CircularProgress';
import Student from '../animate.json';
import Lottie from 'lottie-react';

import './Home.css';


function Home({ handleopenNav, opennav }) {
    const arr = ["Programmer", "Web Developer", "Web Designer"];
    const [role, setrole] = useState("");

    const timer = ms => new Promise(res => setTimeout(res, ms))
    async function load() { // We need to wrap the loop into an async function for this to work
        let i = 0;
        while (i < 3) {
            setrole(arr[i]);
            await timer(2000); // then the created Promise can be awaited
            i = i + 1;
            if (i === 3) {
                i = 0;
            }
        }
    }

    const scrollhome = () => {
        window.scrollBy(0, 0)
    }
    const scrollabout = () => {
        window.scrollBy(0, 600)
    }
    const scrollskill = () => {
        window.scrollBy(0, 1100)
    }
    const scrollprojects = () => {
        window.scrollBy(0, 1600)
    }
    const scrollcontact = () => {
        window.scrollBy(0, 4500)
    }

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // for sending email
    const form = useRef();
    const [issubmited, setissubmited] = useState(false);

    const sendEmail = (e) => {
        document.getElementById('submitbtn').setAttribute("disabled", "disabled");
        e.preventDefault();
        const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
        const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID;
        const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
            .then((result) => {
                form.current.reset();
                window.alert('Message sent successfully');
                console.log(result.text);
            }, (error) => {
                console.log(error.error);
            });
        document.getElementById('submitbtn').removeAttribute("disabled");
        setissubmited(false);
    };

    const setsubmitfun = () => {
        setissubmited(true);
    }

    const fun = () => {
        window.scrollBy(0, 0);
        handleopenNav(!opennav);
    }

    return (
        <>
            <div className="home">
                <div className="navbar">
                    <div className="navleft">
                        <h3>© Designed By Alok</h3>
                        <div className="menudiv">
                            {!opennav ? <MenuIcon className='menu' fontSize="large" onClick={(e) => { fun() }} /> : ''}
                        </div>
                    </div>
                    <div className="navright">
                        <p onClick={() => { scrollhome() }}>Home</p>
                        <p onClick={() => { scrollabout() }}>About</p>
                        <p onClick={() => { scrollskill() }}>Skills</p>
                        <p onClick={() => { scrollprojects() }}>Projects</p>
                        <p onClick={() => { scrollcontact() }}>Contact</p>
                    </div>
                </div>
                <div className="intro">
                    <h4>Hi There, I am → </h4>
                    <h1 className='name'>Alok Kumar Rai</h1>
                    <h1 className="introh12">I'm a <span className='role'>{role}</span></h1>
                    <p>I'm a full-stack Web Developer. I love to build big, scalable industry-ready products. <br /> Looking forward to working in the industry and contributing to real-life projects as a Software Engineer!</p>
                </div>
                <div className="links">
                    <LinkedInIcon className='linksicon' onClick={() => { window.open('https://www.linkedin.com/in/alok-kumar-rai-3261b21ba/', '_blank') }} />
                    <a className='linksicon' href="mailto: alokkumarrai2003@gmail.com"><EmailIcon className='linksicon' /></a>
                    <GitHubIcon className='linksicon' onClick={() => { window.open('https://github.com/Alok530', '_blank') }} />
                    <InstagramIcon className='linksicon' onClick={() => { window.open('https://www.instagram.com/rajalok530/', '_blank') }} />
                </div>
                <div className="resume">
                    <button><a href="/image/Alok_Resume.pdf" download>Download My Resume</a></button>
                </div>

                <div className="about">
                    <h1>About Me</h1>
                    <div className="aboutdiv">
                        <div className="aboutleft">
                            <p>Hi there! I am Alok! I am passionate about building the things. Love to solve real world problems. I am 3 ☆ at LeetCode (solved 500+) problems and (1550+ max) rating at CodeChef. Currently 1st 🥇at GeeksForGeeks Institute Portal (solved 600+) problems.</p>
                            <p>I love to build big, scalable industry-ready products. I am a Full Stack Web Developer. I've worked on different projects. I have done Frontend with vanillaJS and ReactJS. Backend with Node and Express. Specialized in M.E.R.N stack. I have worked with MongoDB as database. Have experience working with Java, C, C++, Python, etc. Looking forward to working in the industry and contributing to real-life projects as a Software Engineer!</p>
                            <p>I am a easy going person and I like to work in a team. Moreover, I always excited to learn new technologies and improve skills.</p>
                        </div>
                        <div className="aboutright">
                            <img src="/image/me.jpeg" alt="" />
                        </div>
                    </div>
                </div>


                {/* ------------ skill section -------------- */}
                <div className="skills">
                    <h1>Skills</h1>
                    <div className="skilldiv">
                        <h3>Programming Languages</h3>
                        <div className="skilltech">
                            <button>C</button>
                            <button>C++</button>
                            <button>JavaScript</button>
                            <button>Java</button>
                            <button>Python</button>
                        </div>
                    </div>
                    <div className="skilldiv">
                        <h3>Web Development Frontend</h3>
                        <div className="skilltech">
                            <button>React.js</button>
                            <button>HTML</button>
                            <button>CSS</button>
                            <button>Bootstrap</button>
                            <button>Material UI</button>
                        </div>
                    </div>
                    <div className="skilldiv">
                        <h3>Web Development Backend</h3>
                        <div className="skilltech">
                            <button>Node.js</button>
                            <button>Express</button>
                            <button>Mongodb</button>
                            <button>MySQL</button>
                        </div>
                    </div>
                </div>

                {/* <div className='ani'>
                    <Lottie animationData={Student} />
                </div> */}


                {/* --------------------- project section ---------------- */}
                <div className="projects">
                    <h1>Projects</h1>
                    <div className="projectsdiv">
                        <div className="projectcol">
                            <div className="projectbox">
                                <img src="/image/shopyfy.png" alt="" />
                                <h3>Shopyfy</h3>
                                <p className="prodecs">Complete Ecommerce Application built using MERN stack. Direct Search, Add to cart, user profile page, tracking orders and more...</p>
                                <p className="protech">React&emsp;Node.js&emsp;Express&emsp;Netlify&emsp;Vercel</p>
                                <button onClick={() => { window.open('https://shopyfys.netlify.app/', '_blank') }}>Live Demo</button>
                            </div>
                            <div className="projectbox">
                                <img src="/image/socialhub.png" alt="" />
                                <h3>SocialHub</h3>
                                <p className="prodecs">Complete Social Media Platform built using MERN stack. Users Posts, Profile, Individual Profile Page with followers, following and more..</p>
                                <p className="protech">React.js &emsp; Node.js &emsp; Express &emsp; Netlify</p>
                                <button onClick={() => { window.open('https://socialshub.netlify.app/', '_blank') }}>Live Demo</button>
                            </div>
                            <div className="projectbox">
                                <img src="/image/enotebook.png" alt="" />
                                <h3>eNoteBook</h3>
                                <p className="prodecs">It's free and easy to use web application for keeping your notes on cloud built using MERN stack. Add, update and delete notes...</p>
                                <p className="protech">React.js &emsp; Node.js &emsp; Express &emsp; Netlify</p>
                                <button onClick={() => { window.open('https://enotesbook.netlify.app/', '_blank') }}>Live Demo</button>
                            </div>
                        </div>
                        <div className="projectcol">
                            <div className="projectbox">
                                <img src="/image/textanalyzer.png" alt="" />
                                <h3>Text Analyzer</h3>
                                <p className="prodecs">Text analysis having functionality like Convert text to uppercase, lowercase, removed extra spaces, count number of words and more...
                                </p>
                                <p className="protech">React.js &emsp; JavaScript &emsp; Bootstrap</p>
                                <button onClick={() => { window.open('https://textsanalyser.netlify.app/', '_blank') }}>Live Demo</button>
                            </div>
                            <div className="projectbox">
                                <img src="/image/ecomerce1.png" alt="" />
                                <h3>Fashion Collection</h3>
                                <p className="prodecs">Complete Ecommerce Application built using MERN stack. Add to cart, user profile page and more...</p>
                                <p className="protech">React.js &emsp; Node.js &emsp; Express &emsp; Netlify</p>
                                <button onClick={() => { window.open('https://fashioncollections.netlify.app/', '_blank') }}>Live Demo</button>
                            </div>
                            <div className="projectbox">
                                <img src="/image/portfolio1.png" alt="" />
                                <h3>Portfolio-v2</h3>
                                <p className="prodecs">My first portfolio website. People can drop their messages, Feedback in message and feedback sections on website and more...</p>
                                <p className="protech">Node.js &emsp; Express &emsp; HTML &emsp; CSS</p>
                                <button onClick={() => { window.open('https://github.com/Alok530/Portfolio', '_blank') }}>Live Demo</button>
                            </div>
                        </div>
                        <div className="projectcol" style={{'justify-content': 'center'}}>
                            <div className="projectbox">
                                <img src="/image/hotelengine.png" alt="" />
                                <h3>Hotel Engine</h3>
                                <p className="prodecs">This website has features like Booking Hotels, Giving Reviews, filter and Sorting Hotels based on price and city..
                                </p>
                                <p className="protech">React.js &emsp;Node &emsp; Javascript &emsp; MongoDb</p>
                                <button onClick={() => { window.open('https://github.com/anuj2801/Hotel-Recommendation-system', '_blank') }}>Github</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* --------------------- feedback section ---------------- */}
                <form ref={form} onSubmit={sendEmail} className="contact">
                    <h1>Keep In Touch</h1>
                    <p>If you have anything to share, go ahead! It could be any joke/funny stuff or any advice. <br /> So yeah just enter details and hit that huge submit button.</p>
                    <div className="contactdiv">
                        <input type="text" required name="user_name" minLength={3} placeholder="I'm excited to know your name!" />
                        <input type="email" required name="user_email" placeholder="Your Email" />
                        <textarea name="message" required cols="30" rows="7" minLength={3} placeholder="Tell me I'm very inquistive."></textarea>
                        <button type="submit" value="Send" id='submitbtn' onClick={(e) => { setsubmitfun() }}>{!issubmited ? 'Submit' : <CircularProgress size="15px" />}</button>
                    </div>
                </form>

                <div>

                </div>


                {/* ---------------------footer section---------------- */}
                <div className="last">
                    <div className="lastdiv lastdiv1">
                        <p>©Alok Kumar Rai</p>
                    </div>
                    <div className="lastdiv lastdiv2">
                        <p onClick={() => { window.open('https://www.linkedin.com/in/alok-kumar-rai-3261b21ba/', '_blank') }}>LinkedIn</p>
                        <p onClick={() => { window.open('https://github.com/Alok530', '_blank') }}>Github</p>
                        <a style={{ color: 'white' }} href="mailto: alokkumarrai2003@gmail.com">Gmail</a>
                    </div>
                    <div className="lastdiv">
                        <p>© Designed By Alok</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;  